/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function () {
  function headerspace() {
    if( $('#epb_container').length ){
      var headerHeight = $('#epb_container').outerHeight();    
      $('.Header').css("padding-top", headerHeight)
    }
  } 
   headerspace();
   $(window).on('resize orientationchange load', function () {
      headerspace();
  });
});

$('.as-select-toggler').on('click', function(){
  $('.as-select').toggleClass('open');
  $('.as-select').toggle();
});
$('.as-select .SizeSwatch').on('click', function(){
  $('.as-select').toggle();
  $('.as-select').removeClass('open');
  $('.as-select-toggler').html($(this).html());
  if ($(this).attr('data-persfieldscount') !== undefined) {
    let count = +$(this).attr('data-persfieldscount');
    $('.line-item-property__field').hide();
    $('.line-item-property__field').each(function() {
      if ( +$(this).attr('data-persfieldindex') <= count ) {
        $(this).show();
      }
    });
  }
});
$(document).on('click', function(e) {
  if ((e.target.closest('.as-select-wrap') == null) && $('.as-select').hasClass('open')) {
    $('.as-select').toggle();
    $('.as-select').removeClass('open');
    
  }
});


if ($('.ProductForm__Inventory').length) {
  const $header = $(".ProductForm__Inventory");
  let prevScroll;
  let lastShowPos;
  const $announcementBar = $('.AnnouncementBar');
  
  $(window).on("scroll", function() {
    const scrolled = $(window).scrollTop();
    const barHeight = $announcementBar.innerHeight()
    if (scrolled > barHeight && scrolled > prevScroll) {
      $header.addClass("header-out");
      lastShowPos = scrolled;
    } else if (scrolled <= barHeight) {
      $header.removeClass("header-out");
    }
    prevScroll = scrolled;
  });
}

if ($('.AnnouncementBar.swiper-container').length) {
  const swiper = new Swiper('.AnnouncementBar.swiper-container', {
    slidesPerView: 1,
    spaceBetween: 10,
    effect: 'fade',
    loop: true,
    speed: 300,
    autoplay: {
     delay: 3000,
   },
  });
}
if ($('.main-slideshow.swiper-container').length) {
  const swiperMainBanner = new Swiper('.main-slideshow.swiper-container', {
    slidesPerView: 1,
    spaceBetween: 10,
    effect: 'fade',
    loop: true,
    speed: 300,
    autoplay: {
     delay: 7000,
   },
  });
}
if ($('.as-collection-list.swiper-container').length) {
  const swiperlist = new Swiper('.as-collection-list.swiper-container', {
    slidesPerView: 1.37,
    spaceBetween: 16,
    navigation: {
      nextEl: ".swiper-button-next.as-collection-arrow",
      prevEl: ".swiper-button-prev.as-collection-arrow",
    },
    breakpoints: {
      992: {
        slidesPerView: 2.5,
        spaceBetween: 16,
        scrollbar: {
          el: '.section-collection-list .swiper-scrollbar',
          draggable: true,
        },
      }
    }
  });
}

if ($('.as-commitment.swiper-container').length) {
  const swiperCommitments = new Swiper('.as-commitment.swiper-container', {
    slidesPerView: 3,
    spaceBetween: 32,
    breakpoints: {
      1007: {
        slidesPerView: 1.37,
        spaceBetween: 16,
      }
    }
  });
}



if ($('.ProductItem--collection .swiper-container').length) {
  $('.as-cip-slider').each(function(){
    var cipSwiper = new Swiper ( $(this), {
      slidesPerView: 1,
      spaceBetween: 0,
      effect: 'fade',
      breakpoints: {
        1007: {
          pagination: {
            el: $(this).find('.swiper-pagination'),
            type: 'bullets',
            clickable: true
          }
        }
      }
    });
  });
}
if ($('.FeaturedCollectionSlider.swiper-container').length) {
  $('.FeaturedCollectionSlider').each(function(){
    var fcSwiper = new Swiper ( $(this), {
      slidesPerView: 4,
      spaceBetween: 32,
      loop: true,
      speed: 300,
      autoplay: {
       delay: 5000,
      },
      navigation: {
        nextEl: $(this).closest('.Container').find('.slider-btn-next'),
        prevEl: $(this).closest('.Container').find('.slider-btn-prev'),
      },
      breakpoints: {
        1007: {
          slidesPerView: 1.37,
          spaceBetween: 16,
          navigation: false,
          loop: false,
          autoplay: false,
        }
      }
    });
  });
}
$(document).on('click', function(e) {
  if ((e.target.closest('.Modal .Container') == null) && ($('.Modal[aria-hidden=false]').length)) {
    $('.Modal__Close').trigger('click');
  }
});



function animateMarquee(el, duration) {
  const innerEl = el.querySelector('.marquee__inner');
  const innerWidth = innerEl.offsetWidth;
  const cloneEl = innerEl.cloneNode(true);
  const cloneEl2 = innerEl.cloneNode(true);
  const cloneEl3 = innerEl.cloneNode(true);
  const cloneEl4 = innerEl.cloneNode(true);
  const cloneEl5 = innerEl.cloneNode(true);
  const cloneEl6 = innerEl.cloneNode(true);
  
  el.appendChild(cloneEl);
  el.appendChild(cloneEl2);
  el.appendChild(cloneEl3);
  el.appendChild(cloneEl4);
  el.appendChild(cloneEl5);
  el.appendChild(cloneEl6);
  
  let start = performance.now();
  let progress;
  let translateX;
  var direction = -1;

  requestAnimationFrame(function step(now) {
    progress = (now - start) / duration;
    if (progress > 1) {
      progress %= 1;
      start = now;
    }
    translateX = innerWidth * progress * direction;
    innerEl.style.transform = `translate3d(${translateX}px, 0 , 0)`;
    cloneEl.style.transform = `translate3d(${translateX}px, 0 , 0)`;
    cloneEl2.style.transform = `translate3d(${translateX}px, 0 , 0)`;
    cloneEl3.style.transform = `translate3d(${translateX}px, 0 , 0)`;
    cloneEl4.style.transform = `translate3d(${translateX}px, 0 , 0)`;
    cloneEl5.style.transform = `translate3d(${translateX}px, 0 , 0)`;
    cloneEl6.style.transform = `translate3d(${translateX}px, 0 , 0)`;
    requestAnimationFrame(step);
  });
};
if ($('#marquee').length) {
  const marquee = document.querySelector('#marquee');
  animateMarquee(marquee, 3000);
}


if ($('.FaqSummary').length) {
  $($('.faq-block__wrap.is-active .Faq__Question')[0]).trigger('click');
  $('.FaqSummary__Link').on('click', function() {
    let faqtarg = $(this).data('faqtarget');
    $('.faq-block__wrap').removeClass('is-active');
    $('.faq-block__wrap[data-faqtarget='+faqtarg+']').addClass('is-active');
    $($('.faq-block__wrap.is-active .Faq__Question')[0]).trigger('click');
  })
}


 $('body').on('DOMSubtreeModified', '.Product__Info', function(){
    if(!$('.Product__Info').hasClass('Product__Info-loaded')){
      $('.Product__Info').addClass('Product__Info-loaded')
      
      setTimeout(function(){
        if($('.a_p_t').text() != '') {
          let additionalPrice = $('.ProductMeta__Price:not(.Price--compareAt)').text();
          $('.ProductForm__AddToCart .Button__SeparatorDot + span').text(additionalPrice);
        }
      },500)
    }
  });

$('body').on('change', '.pplr_select.pplraddprice', function() {
  setTimeout(function(){
    if($('.a_p_t').text() != '') {
      let additionalPrice = $('.ProductMeta__Price:not(.Price--compareAt)').text();
      $('.ProductForm__AddToCart .Button__SeparatorDot + span').text(additionalPrice);
    }
  },500)
});

$('body').on('change', '.Select--primary select[name="id"]', function() {
  setTimeout(function(){
    if($('.a_p_t').text() != '') {
      console.log($('.ProductMeta__Price').text());
      $('.ProductForm__AddToCart .Button__SeparatorDot + span').text($('.ProductMeta__Price:not(.Price--compareAt)').text());
    }
  },500)
});





function _addMeToCart(e, el) {
  e = e || window.event;
  e.preventDefault();

  let formData = {
    'items': [
      {
        'id': el.dataset.variant_id,
        'quantity': 1
      }
    ]
  };
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then((resp) => {
    return resp.json();
  })
  .then((data) => {
    console.log('jhfkjdhgfjd,hnk');
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  })
  .catch((err) => {
    console.error('Error: ' + err);
  })
}


function _addWrapToCart(e, el) {
  e = e || window.event;
  e.preventDefault();
  let giftMes = $('#gift-message').val();
  let formData = {
    'items': [
      {
        'id': el.dataset.variant_id,
        'quantity': 1,
        'properties': {
          'Message': ''
        }
      }
    ]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then((resp) => {
    return resp.json();
  })
  .then((data) => {
console.log('ggggggggggggggggggg,hnk');
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  })
  .catch((err) => {
    console.error('Error: ' + err);
  })
}

function _deleteMe(e) {
  let mEl = $('input[id*="updates_'+giftWrapRemoveId+'"]').closest('.CartItem__Actions').find('.CartItem__Remove');
  mEl[0].click();
}

$('body').on('click', '#is-a-gift input[type="checkbox"]', function(e) {
  // console.log('change');
  if (e.target.checked) {
        console.log('change +');
        _addWrapToCart(e,this);
      } else {
        let elemas = $('#giftRemoveLink');
        console.log('change -');
        elemas[0].click();
      }
}); 

$('.asMobileSubmenuToggler').on('click', function(){
  if ($(this).closest('.asMobileMenu__Item[aria-haspopup="true"]').length) {
    $(this).next('div').attr('aria-hidden', 'false');
  }
});
$('.asMobileSubmenuClose').on('click', function(){
  $(this).closest('div[aria-hidden="false"]').attr('aria-hidden', 'true');
});

window.addEventListener('pplrAddToCartCompleted' , function(e) {
  console.log('added');  
  if ($(".acco-title-content").find("input[name='protection_product']:checked").length !== 0) {    
    var pplrvariantid = $(".acco-title-content").find("input[name='protection_product']:checked").val();
    
    if( typeof pplrvariantid !="undefined" && pplrvariantid !="" ){
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: { "id": pplrvariantid, "quantity": 1 },
        success: function(data){
          console.log(data);
        },
        error: function(error) {
          console.log(error);
        }
      });    
    }
  }
  
  localStorage.setItem('opencartdrawer', 'open');
})



$('document').ready(function(){
  if(localStorage.getItem('opencartdrawer')) {

    setTimeout(function(){
      $('#sidebar-cart').attr('aria-hidden', 'false');
      //$('html').addClass('no-scroll');
      $('.PageOverlay').addClass('is-visible');
      function checkForClass(className) {
        const $foundElement = $(`.pplr_subtotal_price`);
        if ($foundElement.length > 0) {
            console.log("Found element:", $foundElement);
            var total_new = $('#sidebar-cart').attr('data-total');
            $('.pplr_subtotal_price').text(total_new);
        }else{
          setTimeout(() => {
            checkForClass(className);
              console.log(`Checking again for class: ${className}`);
               }, 1000);
          }
      }  checkForClass('pplr_subtotal_price');
    }, 500);

    localStorage.removeItem('opencartdrawer');

  }
  $('#sidebar-cart .Drawer__Close').on('click', function () {
    $('#sidebar-cart').attr('aria-hidden', 'true');
    //$('html').removeClass('no-scroll');
    $('.PageOverlay').removeClass('is-visible');
  })
  if($('.section-announcement-bar').length > 0){
    var height = $('.section-announcement-bar').height();
    // $('.shopify-section--header').css('top',(height-2)+'px');
    //$('.shopify-section--header').css('top',(height)+'px');
  }

  function checkpplr_text(){
    if($('.template-product').length > 0){
      if($('.pplr-wrapper.pplr-text').length > 0){
        $('.pplr-wrapper.pplr-text').each(function(){
          $(this).find('.key_layout').addClass('hide_key_layout');
        });
      }else{
        setTimeout(function(){
          checkpplr_text();
        },1000);
      } 
    }
  }
  checkpplr_text();
  
  $('body').on('click','.product-personalizer .pplr-text .pplr_text, .product-personalizer .pplr-text .key_layout span',function(e){
    e.preventDefault();
    $(this).parents('.pplr-text').find('.key_layout').addClass('hide_key_layout');
  });
  $('body').on('click','.product-personalizer .pplr-text .key_layout_sub',function(e){
    e.preventDefault();
    $(this).parent().find('.key_layout').removeClass('hide_key_layout');
  });
  
});


$('body').on('change paste', '#gift-message', function(e) {
  e = e || window.event;
  e.preventDefault();

  var row = 1;
  $('.pplr_cart_row').each(function () {
    if($(this).find('.CartItem__Title a').text() == 'Premium package'){
      row = $(this).attr('data_pplr_row');
    }
  })
  console.log(row)
  console.log('field was updated');
  let giftMes = $('#gift-message').val();
  $.ajax({
    url: '/cart/change.js',
    // type: 'post',
    dataType: 'json',
    data: {
      line: row,
      quantity: 1,
      properties: {
        Message: giftMes,
      }
    },
    success: function(data){

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    }
  });
  

});
// ------ colection page image change

$('body').on('click' , '.color_option' , function () {
 if(!$(this).hasClass("active")) {
   $(this).closest('.color_list').find('.color_option').removeClass('active');
      $(this).addClass("active");
  } else {
      $(this).removeClass("active");
  }
 $(this).addClass('active');
   if ($(window).width() > 768) {
     var dataimg = $(this).attr('data-img');
     console.log("768");
    var imgadd = $(this).parents('.ProductItem').find('.color_img_show').attr('srcset', dataimg);
  } else {
      var dataimgm = $(this).attr('data-img-mob');
     var imgaddm = $(this).parents('.ProductItem').find('.color_img_show').attr('srcset', dataimgm);
       console.log("991");
  }
});

  
$(document).ready(function(){
   $("body").on("click", ".included-block", function(){
     var isDisabled = $(this).find("input[type='hidden']").prop('disabled');
     $(this).find("input[type='hidden']").prop('disabled', !isDisabled);     
   })

   $("body").on("click",".Product__SlideshowNav--thumbnails .flickity-prev-next-button", function(){
     if( $(this).hasClass("previous")){
       $(".Product__SlideshowMobileNav .Product__SlideshowNavArrow--previous").click();
     }else{
       $(".Product__SlideshowMobileNav .Product__SlideshowNavArrow--next").click();
     }
   })   
 });

// $('body').on('mouseover', '#sidebar-cart .Cart__Checkout', function(e) {
//   // e = e || window.event;
//   // e.preventDefault();
//     let giftMes = $('#gift-message').val();
//     let isGifted = 'No'
//     if ($('#isGift').attr('checked')=='checked') {
//       isGifted = 'Yes';
//     }
      
//     console.log(giftMes+' '+isGifted);

//   $.ajax({
//     url: '/cart/update.js',
//     type: 'post',
//     dataType: 'json',
//     data: {
//       attributes: {
//         'Add premium package': isGifted,
//         'Gift Message': giftMes
//       }
//     },
//     success: function(data){
//       console.log(data);
//       document.documentElement.dispatchEvent(new CustomEvent('product:added'));
//       console.log('ok');
//     }
//   });
//     // console.log('mousedown');
// });

function headerspace() {
    if ($(window).width() > 1139) {
        var customer_serviceHeight = $('.customer-service').outerHeight();
        $('.Header--center .Header__MainNav').css("bottom", customer_serviceHeight);
    }
}
// headerspace();
$(window).on('resize load', function () {
    // headerspace();
});


// 07-11-2024 = Jewelry Protection Accordian Js [PDP Page]
$('.benefit-offer-acco .acco-heading .acco-title-content input[type=checkbox]').change(function() { 
    $('.benefit-offer-acco .acco-heading .acco-title-content').not($(this).closest('.acco-heading')).removeClass('active').next('.acco-content').slideUp();
    if (!$(this).closest('.acco-heading').next('.acco-content').is(':visible')) {
        $(this).closest('.acco-heading').addClass('active').next('.acco-content').slideDown();
    } else {
        $(this).closest('.acco-heading').removeClass('active').next('.acco-content').slideUp();
    }
});

// $(document).ready(function () {
//   function headerspace() {
//     if( $('#epb_container').length ){
//       var headerHeight = $('#epb_container').outerHeight();    
//       $('.Header').css("padding-top", headerHeight)
//     }
//   } 
//    headerspace();
//    $(window).on('resize orientationchange load', function () {
//       headerspace();
//   });
// });

